exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-list-item[data-v-4ef203da]{\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n}\n", ""]);

// exports
